$shm_hitalama_process_logs_row $mol_view
	process null
	sub /
		<= Head $mol_view
			sub /
				<= Status $mol_view
					sub / <= status \
				<= Duration $mol_view
					sub / <= duration \
				<= Name $mol_view
					sub / <= name \
				<= Started $mol_speck
					value <= started_at \
		^ children_visible / <= Children $mol_list
			sub <= child_rows /
	Child* $shm_hitalama_process_logs_row
		process <= child_process* null
